export default __webpack_public_path__ + "static/media/sarahphoto.4edf1c85.jpg";